import { components } from "@certn/legacy-api/generated-schemas/people";

import { FieldType } from "../types";

export function ConsentField(
  field: components["schemas"]["ConsentsAcknowledgedField"]
): FieldType<components["schemas"]["ConsentsAcknowledgedField"]> {
  return {
    field,
    isCompleted: field.value,
  };
}
